import { queryPremiumRateForTPDUDR as queryPremiumRate } from 'core/service/rider/query-premium-rate'
import { calculateRiderPremiumForTPDUDR as calculateRiderPremium } from 'core/service/rider/premium-calculation'

export default {
  calculateRiderPremium,
  queryPremiumRate,
}
